const TEXTUAL_INPUT_TYPES = new Set([
  'text',
  'search',
  'email',
  'url',
  'tel',
  'password',
  'number',
]);

/** 画布 / 工作流编辑器等应自行处理 undo/redo 的区域选择器。 */
const DEFER_INPUT_HISTORY_SHORTCUT_SELECTORS = [
  '.gedit-playground',
  '.gedit-playground-layer',
  '.gedit-selector-bounds-background',
  '.gedit-selector-bounds-foreground',
  '.gedit-selector-box',
] as const;

/**
 * 判断元素是否为应自行处理 undo/redo 的文本类可编辑控件。
 */
export function isExternalTextualEditableElement(element: HTMLElement | null): boolean {
  if (!element) {
    return false;
  }
  if (element instanceof HTMLTextAreaElement) {
    return true;
  }
  if (element.isContentEditable) {
    return true;
  }
  if (element instanceof HTMLInputElement) {
    return TEXTUAL_INPUT_TYPES.has(element.type || 'text');
  }
  return false;
}

/**
 * 判断焦点是否位于输入框容器内（含联想 / @ 弹层等 Portal 区域）。
 */
export function isActiveElementInsideInputArea(
  activeElement: HTMLElement | null,
  inputAreaRoot: HTMLElement | null | undefined,
): boolean {
  if (!activeElement || !inputAreaRoot) {
    return false;
  }
  return inputAreaRoot === activeElement || inputAreaRoot.contains(activeElement);
}

/**
 * 判断焦点是否在画布等工作流区域，此类区域应自行消费 Cmd+Z / Cmd+Shift+Z。
 */
export function shouldDeferInputHistoryShortcutToCanvas(activeElement: HTMLElement | null): boolean {
  if (!activeElement) {
    return false;
  }
  return DEFER_INPUT_HISTORY_SHORTCUT_SELECTORS.some(
    (selector) => activeElement.closest(selector) != null,
  );
}

/**
 * 判断是否应让其它可编辑区域自行处理 undo/redo，而不由聊天输入框 document 监听拦截。
 */
export function shouldSkipInputHistoryShortcutForExternalEditable(
  activeElement: HTMLElement | null,
  options?: {
    activeInsideEditor?: boolean;
    inputAreaRoot?: HTMLElement | null;
  },
): boolean {
  if (!activeElement) {
    return false;
  }
  if (options?.activeInsideEditor) {
    return false;
  }
  if (isActiveElementInsideInputArea(activeElement, options?.inputAreaRoot)) {
    return false;
  }
  return isExternalTextualEditableElement(activeElement);
}
